export default __webpack_public_path__ + "static/media/Cobertura-WiFi-1.79552c64.jpg";